import React from 'react';
import { developmentRoles } from '../data/governance';
export function DirectorDevelopment() {
  return <div className="grid gap-10 lg:grid-cols-12" data-id="element-126" data-mp="15z6dmwqlyo5s">
      <div className="rounded-md bg-forest-soft p-7 lg:col-span-4" data-id="element-127" data-mp="15xlltevohjbm">
        <p className="font-serif text-6xl text-forest" data-id="element-128" data-mp="1axgcpifge8wo">400+</p>
        <p className="mt-3 text-base leading-relaxed text-charcoal" data-id="element-129" data-mp="1fq9j0aqklpav">
          Trustees trained through CGIAR board orientation courses held around the world, 2004 – 2019.
        </p>
      </div>

      <div className="lg:col-span-8" data-id="element-130" data-mp="1opwk0vfe0t3e">
        <ul data-id="element-131" data-mp="1oouvpp9d2a3q">
          {developmentRoles.map(r => <li key={r.role} className="border-t border-rule py-5 first:border-t-0 first:pt-0" data-id="element-132" data-mp="1tpsfg6a0rc7c">
              <div className="flex flex-col gap-1 sm:flex-row sm:items-baseline sm:justify-between sm:gap-6" data-id="element-133" data-mp="1yoddq05pnlt5">
                <h3 className="font-serif text-lg text-forest" data-id="element-134" data-mp="3vhfb4l4uvva5">{r.role}</h3>
                <p className="shrink-0 whitespace-nowrap text-sm tabular-nums text-charcoal-muted" data-id="element-135" data-mp="4akwfkh8asal">{r.dates}</p>
              </div>
              <p className="mt-0.5 text-sm font-medium text-wheat-dark" data-id="element-136" data-mp="3c54b9ctl9b3e">{r.organisation}</p>
              <p className="mt-2 text-sm leading-relaxed text-charcoal" data-id="element-137" data-mp="37dvxy5p515ky">{r.text}</p>
            </li>)}
        </ul>
      </div>
    </div>;
}